import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { handleSubmitFolderDelete } from 'components/views/FounderVault/_helpers/founderVault.events';
import { $form, $view } from 'signals/global.signals';

const FounderFolderDeleteModal = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'founder-folder-delete'}
    title="Delete Folder"
    onHide={handleHideModal}
    onPrimaryClick={handleSubmitFolderDelete}
    primaryButtonText="Delete"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    isLoading={$view.value?.isModalLoading}
  >
    <p>Are you sure you want to delete {$form.value.name}?</p>
  </SimpleModal>
);

export default FounderFolderDeleteModal;
